import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

function PrivacyPolicy() {
	return (
		<>
			<Helmet>
				<title>Privacy Policy | Apex Specialty Contracting LLC</title>
				<meta name="description" content="Privacy Policy for Apex Specialty Contracting LLC — how we collect, use, and protect your personal information." />
			</Helmet>
			<PageHeader
				title="Privacy Policy"
				subtitle="Last updated: January 1, 2025"
			/>
			<section className="section">
				<div className="container" style={{ maxWidth: 780 }}>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 8px' }}>About This Policy</h3>
						<p className="helper" style={{ margin: 0 }}>
							APEX SPECIALTY CONTRACTING LLC ("Apex," "we," "our," or "us"), operating at
							183 Highland Rd, Tarpon Springs, FL 34689, provides residential and commercial roofing
							and storm restoration services. This Privacy Policy describes how we collect, use, and
							protect the personal information you share with us.
						</p>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>Information We Collect</h3>
						<ul className="helper" style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
							<li><strong>Contact details:</strong> name, email address, phone number, and property address.</li>
							<li><strong>Service information:</strong> roofing service requested, project description, and any photos you submit.</li>
							<li><strong>Communication records:</strong> messages sent through our contact form or by email.</li>
							<li><strong>SMS consent data:</strong> timestamp, consent method, and referring page when you opt in to text messages.</li>
							<li><strong>Automatically collected data:</strong> browser type, IP address, and pages visited via standard web analytics.</li>
						</ul>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>How We Use Your Information</h3>
						<ul className="helper" style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
							<li>Scheduling and performing roofing inspections, estimates, and projects.</li>
							<li>Sending appointment reminders, project status updates, and related service messages.</li>
							<li>Sending marketing messages (estimates, promotions, seasonal offers) when you have provided SMS consent.</li>
							<li>Coordinating with insurance adjusters on your behalf when requested.</li>
							<li>Improving our website and services based on usage patterns.</li>
						</ul>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>SMS Communications</h3>
						<p className="helper" style={{ margin: '0 0 8px' }}>
							With your consent, we may send text messages about roofing estimates, appointment reminders,
							project status updates, and promotional offers. Message frequency varies.
							<strong> Message and data rates may apply.</strong>
						</p>
						<p className="helper" style={{ margin: '0 0 8px' }}>
							<strong>To opt out:</strong> Reply <strong>STOP</strong> to any message at any time.
							You may also use our <Link to="/opt-out">online opt-out form</Link>.
						</p>
						<p className="helper" style={{ margin: 0 }}>
							<strong>Consent is not required</strong> to receive roofing services. See our{' '}
							<Link to="/sms-policy">SMS Policy</Link> for full details.
						</p>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>Information Sharing</h3>
						<ul className="helper" style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
							<li>We share information with service providers who assist with scheduling, CRM, and communications — only as necessary to fulfill your request.</li>
							<li>We may share information with insurance companies or adjusters when you request claims assistance.</li>
							<li><strong>We do not sell, rent, or share your mobile phone number with third parties for their marketing purposes.</strong></li>
							<li>We may disclose information when required by law or to protect legal rights.</li>
						</ul>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>Data Security &amp; Retention</h3>
						<p className="helper" style={{ margin: 0 }}>
							We store information using industry-standard security measures. Consent records are retained
							as required for regulatory compliance. You may request deletion of your personal information
							by contacting us; note that some records may be retained as required by law.
						</p>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>Your Rights</h3>
						<ul className="helper" style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
							<li>Request access to or a copy of the personal information we hold about you.</li>
							<li>Request correction of inaccurate data.</li>
							<li>Request deletion of your personal information (subject to legal retention requirements).</li>
							<li>Opt out of marketing SMS at any time by replying STOP.</li>
							<li>California residents may have additional rights under CCPA; contact us for requests.</li>
						</ul>
					</div>

					<div className="card" style={{ padding: '24px 28px' }}>
						<h3 style={{ margin: '0 0 8px' }}>Contact Us</h3>
						<p className="helper" style={{ margin: 0 }}>
							For privacy questions or data requests, contact:<br />
							<strong>APEX SPECIALTY CONTRACTING LLC</strong><br />
							183 Highland Rd, Tarpon Springs, FL 34689<br />
							Phone: <a href="tel:+19163160696">(916) 316-0696</a><br />
							Email: <a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a>
						</p>
					</div>

				</div>
			</section>
		</>
	);
}

export default PrivacyPolicy;
